import React from 'react';

import {LOCKED_ANSWERS_NOTICE_ID} from '../shared/annotationFreeze';
import {useIsAnnotationModeActive} from './useIsAnnotationModeActive';

/**
 * The reason answer choices ignore input while Highlights & Notes is on (SC 3.3.2);
 * locked answer groups describe themselves by it.
 */
export default function LockedAnswersNotice() {
  const areAnswersLocked = useIsAnnotationModeActive();

  if (!areAnswersLocked) {
    return null;
  }

  return (
    <span id={LOCKED_ANSWERS_NOTICE_ID} className='sr-only'>
      Answer choices are locked while Highlights &amp; Notes is on. Turn it off to choose an answer.
    </span>
  );
}
